import React, { useState, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Alert,
  Box,
  CardContent,
  Container,
  Grid,
  Typography,
} from '@mui/material'
import { Fetching } from '../../components/Fetching'
import { StyledCard } from '../../components/StyledCard'
import { BackButton } from '../../components/navigation/BackButton'
import { WebcamComponent } from '../video/Webcam'
import { WorkerInfoFormNew } from './enrollment-steps/WorkerInforFormNew'
import { useSessionStorage } from '../../hooks/useSessionStorage'
import { guessUserTZ } from '../../lib/time'
import { useMutateWorkerRegister } from './enrollment-steps/hooks'
import SnackBarContext from '../../context/SnackBarContext'

export const EnrollWorkerNew = (props: any) => {
  const [workerPhotoRaw, setWorkerPhotoRaw] = useState<any | undefined>(null)
  const [sessionUser] = useSessionStorage('user', {})
  const [errorRegistering, setErrorRegistering] = useState<boolean>(false)
  const [errorFeedback, setErrorFeedback] = useState<string | undefined>('')
  const {
    mutateAsync: registerUserAsync,
    isLoading: isRegistering,
    isError,
  } = useMutateWorkerRegister('worker')
  const onImageCaptureHandler = (image: any) => {
    setWorkerPhotoRaw(image)
  }
  const { toggleSnackbar } = useContext(SnackBarContext)
  const navigate = useNavigate()

  const onSaveHandler = async (worker: any) => {
    const formData = new FormData()
    formData.append('file', workerPhotoRaw)
    if (!(workerPhotoRaw instanceof Blob)) {
      setErrorRegistering(true)
      setErrorFeedback('Something went wrong, invalid image file provided!')
      return
    }

    const newWorker = {
      ...worker,
      account: sessionUser?.accountId?.id,
      timeZone: guessUserTZ(),
      org_id: sessionUser?.accountId?.organizationId,
      companyId: sessionUser?.accountId?.id, // this is the account id used for indexing.
    }
    formData.append('workerData', JSON.stringify(newWorker))
    try {
      await registerUserAsync(formData)
      navigate('/workers')
      toggleSnackbar('Worker added successfully', 'success')
    } catch (error: any) {
      console.error('error', error)
      if (error) {
        setErrorRegistering(true)
        setErrorFeedback('Something went wrong, please enroll worker again!')
      }
    }
    return false
  }

  return (
    <>
      <Box sx={{ marginTop: 1, marginLeft: 2, marginRight: 2 }}>
        <Container maxWidth='lg'>
          <Grid item xs={12} sm={6} md={4} lg={4}>
            <BackButton steps={-1} />
          </Grid>
          <StyledCard>
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Typography variant='h4' gutterBottom>
                    Worker Info
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {errorRegistering && (
                    <Alert severity='error'>
                      Could not register worker: {errorFeedback}
                    </Alert>
                  )}
                  {isRegistering ? (
                    <Fetching />
                  ) : (
                    <WorkerInfoFormNew
                      saveWorker={onSaveHandler}
                      workerData={null}
                      disabled={false || isRegistering}
                      workerPhotoRaw={workerPhotoRaw}
                    />
                  )}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  sx={{ alignContent: 'center', alignItems: 'center' }}>
                  <WebcamComponent onImageCapture={onImageCaptureHandler} />
                </Grid>
              </Grid>
            </CardContent>
          </StyledCard>
        </Container>
      </Box>
    </>
  )
}
